import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Award } from "lucide-react";

const WystepNaGale = () => (
  <SeoPageLayout title="Występ komediowy" titleAccent="na galę">
    <SeoSection title="Komediowy akcent na gali firmowej">
      <p>Gala firmowa to wydarzenie o szczególnym prestiżu - wręczenie nagród, podsumowanie roku, jubileusz. Występ komediowy dodaje gali lekkości i elegancji, przełamując oficjalny charakter wieczoru. Profesjonalny komik potrafi bawić nawet najbardziej wymagającą publiczność, zachowując przy tym klasę i styl odpowiedni dla takiego wydarzenia.</p>
    </SeoSection>

    <SeoSection title="Komik na gali - co oferujemy?">
      <SeoStyledList items={[
        "Prowadzenie całej gali z elementami stand-upu",
        "Krótki występ komediowy między punktami programu",
        "Roast laureatów nagród (w formie ciepłej i życzliwej)",
        "Interaktywny show z udziałem gości",
        "Komediowe podsumowanie roku firmy"
      ]} />
    </SeoSection>

    <SeoSection title="Elegancki humor na poziomie">
      <p>Na gali nie ma miejsca na żarty niskiego lotu. Nasi komicy specjalizują się w inteligentnym, wyrafinowanym humorze, który bawi zarząd, pracowników i zaproszonych gości jednocześnie. Humor jest uniwersalny, ale jednocześnie spersonalizowany - nawiązuje do osiągnięć firmy, branży i wspólnych doświadczeń.</p>
      <SeoHighlightBox icon={Award}>
        Nasi komicy mają doświadczenie na galach od 50 do ponad 1000 gości - od kameralnych ceremonii po wielkie wydarzenia branżowe.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Gale, na których występowaliśmy">
      <p>Mamy doświadczenie w występach na galach różnej wielkości - od kameralnych ceremonii dla 50 osób po wielkie wydarzenia dla ponad tysiąca gości. Występowaliśmy na galach branżowych, galach nagród, bankietach charytatywnych i uroczystych kolacjach biznesowych. Każde z tych doświadczeń nauczyło nas, jak dopasować format do oczekiwań organizatorów.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default WystepNaGale;
